import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";
import StateOfficeElectionMenuComponentController from "./StateOfficeElectionMenuController";

const StateOfficeElectionMenuComponent = {
    name: "tbStateOfficeElectionMenu",
    config: {
        bindings: {
            useCheckBoxes: "@tbUseCheckBoxes",
            onSelectedItem: "&tbOnSelectedItemFn",
            onCheckedItems: "&tbOnCheckedItemsFn"
        },
        controller: StateOfficeElectionMenuComponentController,
        controllerAs: StateOfficeElectionMenuComponentController.controllerAs,
        template: StateOfficeElectionMenuComponentController.template
    }
};

const stateOfficeElectionMenuComponentDependencies = DependencyListBuilder([
    StateOfficeElectionMenuComponentController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.directives.state-office-election-menu",
        stateOfficeElectionMenuComponentDependencies
    )
    .component(StateOfficeElectionMenuComponent.name, StateOfficeElectionMenuComponent.config)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/directives/StateOfficeElectionMenu/index.js
// module id = Rd6/
// module chunks = 1